// Function to add the webform to the right column
function webformPosition(achaWebform) {
    // Find the .basic-page element
    const basicPage = document.querySelector(".basic-page");
    // If .basic-page or webform doesn't exist, stop
    if (!basicPage || !achaWebform) return;

    // Find the right column inside .basic-page
    const rightColumn = basicPage.querySelector(".page-right-column");
    // If right column exists, add the webform at the end
    if (rightColumn) {
        rightColumn.append(achaWebform);

        setTimeout(()=> {
            achaWebform.classList.add("on");
        }, 150);
    }
}

// Create a MutationObserver to watch for DOM changes
const observer = new MutationObserver((mutations, obs) => {
    // Look for the webform element by id
    const achaWebform = document.querySelector('[id^="block-acha-webform"]');

    // If found
    if (achaWebform) {
        webformPosition(achaWebform); // Add the webform
        obs.disconnect(); // Stop observing after first match
    }
});

// Start observing changes in the whole body
observer.observe(document.body, { childList: true, subtree: true });

// When the DOM is fully loaded
window.addEventListener('DOMContentLoaded', () => {
    // Check if the webform is already in the page
    const achaWebform = document.querySelector('[id^="block-acha-webform"]');

    // If it exists, add it to the right column
    if (achaWebform) webformPosition(achaWebform);
});